import { sanitize } from 'dompurify';
import React from 'react';
import { CerebroDrawer, CerebroHeading, CerebroLink, CerebroText } from '../../shared/components';
import { DataRoomTeaserPreview } from '../../shared/models';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { Alert, useTheme } from '@mui/material';

interface TeaserResponseFormProps {
	dataRoomGuid: string | undefined;
	preview: DataRoomTeaserPreview | null;
	close: () => void;
}

export const TeaserEmailPreview: React.FC<TeaserResponseFormProps> = ({ dataRoomGuid, preview, close }) => {
	const theme = useTheme();

	return (
		<CerebroDrawer open={preview != null} onClose={() => close()} PaperProps={{ sx: { width: '850px' } }}>
			<CerebroHeading size="h2" sx={{ marginBottom: 3 }}>
				{preview?.subject}
			</CerebroHeading>

			<Alert
				severity="info"
				sx={{
					marginBottom: 3,
					boxShadow: '2px 2px 2px 2px ' + theme.palette.primary.main,
					border: 'none',
					backgroundColor: 'white',
				}}
			>
				<p>For teasers marked to include referral language, the following will be included in the teaser:</p>
				<br />
				<p>
					You are receiving this deal invite from Cerebro's loan marketplace which is only available to
					lenders who have agreed to pay Cerebro referral fees for closed transactions.{' '}
					<a href="#">Click here</a> to review the referral fee arrangement we have on file for your lending
					institution.{' '}
					<strong>
						If you do not intend to pay a referral fee for this opportunity, please decline it or contact me
						to discuss it further.
					</strong>
				</p>
			</Alert>

			<div id="emailPreview" dangerouslySetInnerHTML={{ __html: sanitize(preview?.html ?? '<p></p>') }}></div>

			{preview?.files && (
				<>
					<CerebroText sx={{ marginTop: 3 }}>Attachments</CerebroText>
					{preview.files.map(file => {
						return (
							<React.Fragment key={file.guid}>
								<CerebroLink
									href={CerebroApiEndpoints.Teasers.AbsoluteDownload(dataRoomGuid, file.guid)}
									target="_blank"
									rel="noreferrer"
								>
									{file.title}
								</CerebroLink>
								<br />
							</React.Fragment>
						);
					})}
				</>
			)}
		</CerebroDrawer>
	);
};
